var isNil = require('./isNil');
var isArray = require('./isArray');

module.exports = function isObject(x) {
  return !isNil(x) && typeof x === 'object' && !isArray(x);
};


//////////////////
// WEBPACK FOOTER
// ./~/tcomb/lib/isObject.js
// module id = 70
// module chunks = 0